var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 12V3C18.9998 2.46957 18.7891 1.96086 18.414 1.58579C18.0389 1.21071 17.5302 1 16.9998 1H4.99978C4.46934 1 3.96064 1.21071 3.58556 1.58579C3.21049 1.96086 2.99978 2.46957 2.99978 3V12M18.9998 12H2.99978M18.9998 12L20.2798 14.55C20.3569 14.703 20.3934 14.8732 20.3858 15.0444C20.3782 15.2155 20.3267 15.3818 20.2364 15.5274C20.1461 15.6729 20.0198 15.7928 19.8698 15.8756C19.7198 15.9584 19.5511 16.0012 19.3798 16H2.61978C2.44847 16.0012 2.27972 15.9584 2.12972 15.8756C1.97972 15.7928 1.8535 15.6729 1.76315 15.5274C1.67281 15.3818 1.62137 15.2155 1.61378 15.0444C1.60618 14.8732 1.64268 14.703 1.71978 14.55L2.99978 12",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.a03f6f478f06d61ed0a697bada0a7524.svg";
export { ForwardRef as ReactComponent };